import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=135bd8f2&scoped=true&"
import script from "./Footer.vue?vue&type=script&scoped=true&lang=js&"
export * from "./Footer.vue?vue&type=script&scoped=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135bd8f2",
  null
  
)

export default component.exports